import PromoCodeWithLink from './promo_code_with_link';

export default PromoCodeWithLink;
